import {
  Table, TableHeader, TableHeaderCell, TableBody, TableRow, TableCell,
  Button, Tooltip, useToastController
} from "@fluentui/react-components";
import {
  ChevronLeftRegular, ChevronRightRegular, Info32Filled, Info32Regular
} from "@fluentui/react-icons";
import { Stack } from '@fluentui/react';
import { addWeeks, subWeeks } from "date-fns";
import { useGlobalStatus } from '../../services/GlobalStatusProvider';
import {useState, useEffect}  from "react";
import TooltipWatcherWidget from '../TooltipWatcherWidget';
import { useNavigate } from "react-router-dom";
import { GetA23UnsubmittedUsers } from '../../services/apiService';
import { TOASTER_ID } from "../../services/toastUtils";
import { showErrorToast } from "../../services/toastUtils";
import ExportToCSV from "../ExportToCSV";


export default function WeeklyTimesheetStatus() {
  const { startLoad, endLoad, useStyles,  currentWeekStart, currentWeekStartDisplay, setCurrentWeekStart } = useGlobalStatus();
  const styles = useStyles();
  const [timesheetData, setTimesheetData] = useState([]);
  const [infoActive, setInfoActive] = useState(false);
  const navigate = useNavigate();
  const { dispatchToast } = useToastController(TOASTER_ID);

  const handleInfoToggle = () => {
    document.body.classList.contains("show-tooltip") ? document.body.classList.remove('show-tooltip') : document.body.classList.add('show-tooltip');
    setInfoActive(!infoActive);
  }

  const loadWeekData = async (weekStart) => {
    startLoad();
    // API request to get the data for the week
    let dataForWeek = [];
    try {
      dataForWeek = await GetA23UnsubmittedUsers(weekStart);
    } catch (error) {
      showErrorToast(dispatchToast, "Request failed or timed out");
    }
    
    setTimesheetData(dataForWeek);
    endLoad();
  };

  const handleWeekChange = async (direction) => {
    const newWeek = direction === "previous"
      ? subWeeks(currentWeekStart, 1)
      : addWeeks(currentWeekStart, 1);
    setCurrentWeekStart(newWeek);

    await loadWeekData(newWeek);
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadWeekData(currentWeekStart);
    };
    fetchData();
  }, []);

  return (
    <div className="timesheet-container">
      <div className="navigation-controls">
        <TooltipWatcherWidget text="Click to go to Admin Home" direction='above'>
          <Button className={styles.buttonPrimary} onClick={() => navigate("/")}>Home</Button>
        </TooltipWatcherWidget>
              <div className="nav-center">
                <TooltipWatcherWidget text="Cycle week">
                <Button
                  className={styles.buttonSecondary}
                  size="large"
                  icon={<ChevronLeftRegular aria-hidden="true" />}
                  onClick={() => handleWeekChange("previous")}
                  aria-label="Go to previous month"
                >
                  Prev
                </Button>
                </TooltipWatcherWidget>
                <span className="month-label" id="month-label">
                  Week of {currentWeekStartDisplay()}
                </span>
                <Button
                  className={styles.buttonSecondary}
                  size="large"
                  icon={<ChevronRightRegular aria-hidden="true" />}
                  onClick={() => handleWeekChange("next")}
                  aria-label="Go to next month"
                >
                  Next
                </Button>
              </div>
              <Tooltip 
                withArrow
                positioning="before"
                relationship="description"
                content={{children: "Click to toggle help", className: styles.tooltip}}>
              {infoActive ? (
                <Info32Filled className="tooltip-filled" onClick={handleInfoToggle} />
              ) : (
                <Info32Regular className="tooltip" onClick={handleInfoToggle} />
              )}
            </Tooltip>
          </div>
 
      <h2>Unsubmitted Users Table</h2>
      <Table className="approval-table">
        <TableHeader>
          <TableRow>
            <TableHeaderCell>User</TableHeaderCell>
            <TableHeaderCell>Status</TableHeaderCell>
            <TableHeaderCell>Export as CSV</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {timesheetData.length === 0 ? (
            <TableRow>
              <TableCell colSpan={2}>All users have submitted!</TableCell>
            </TableRow>
          ) : (
            timesheetData.map((user, index) => (
              (user.timesheetStatus === "Not Submitted") &&
              <TableRow key={index}>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.timesheetStatus}</TableCell>
                <TableCell>
                  <Stack horizontal tokens={{ childrenGap: 8 }}>
                    <ExportToCSV email={user.email} type="month" text="Month"></ExportToCSV>
                    <ExportToCSV email={user.email} type="week" text="Week"></ExportToCSV>
                  </Stack>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      <br/>
      <h2>Submitted/Approved/Rejected Users Table</h2>
      <Table className="approval-table">
        <TableHeader>
          <TableRow>
            <TableHeaderCell>User</TableHeaderCell>
            <TableHeaderCell>Status</TableHeaderCell>
            <TableHeaderCell>Export as CSV</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {timesheetData.length === 0 ? (
            <TableRow>
              <TableCell colSpan={2}>All users have submitted!</TableCell>
            </TableRow>
          ) : (
            timesheetData.map((user, index) => (
              (user.timesheetStatus !== "Not Submitted") &&
              <TableRow key={index}>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.timesheetStatus}</TableCell>
                <TableCell>
                  <Stack horizontal tokens={{ childrenGap: 8 }}>
                    <ExportToCSV email={user.email} type="month" text="Month"></ExportToCSV>
                    <ExportToCSV email={user.email} type="week" text="Week"></ExportToCSV>
                  </Stack>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
